module.exports = __webpack_public_path__ + "static/6-103af249cafcc911ec64c289adb41010.jpg";